import { State } from "../../state/state";
import { useState } from "react";
import { ReactElement } from "react";
import { Button } from "components/common/Button";
import { ExternalLink } from "components/common/ExternalLink";

type SendingStatus = "idle" | "emptyMessage" | "sending" | "sent" | "error";

export function UndevelopedBuildingZones(props: {
  state: State;
}): ReactElement {
  const state = props.state;

  const template =
    "Kontakt: [Vorname Name], [Büro], [Telefon], [E-Mail]\nGemeinde: [Gemeindebezeichnung]\nOrtsteil: [Ortsteilbezeichnung]\nGrundstücknummer: [Zahl]\nBauzonenbezeichnung: [Text]\nKorrekturantrag: [Fläche ist bebaut] oder [Fläche ist nicht bebaut]\nBegründung: [Text]";

  function handleTextAreaChanged(e: any) {
    setMessage(e.target.value);
    setSendingStatus("idle");
  }

  function fillInTemplate() {
    setMessage(template);
  }

  async function send() {
    if (state.selectedMunicipality !== undefined) {
      if (message.length > 0) {
        setSendingStatus("sending");

        const formData = new URLSearchParams();
        formData.append("message", message);
        formData.append("gemeinde", state.selectedMunicipality.gemeinde);

        try {
          const response = await fetch(
            `${process.env.REACT_APP_API_BASE_URL}/reportCorrections`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
              },
              body: formData.toString(),
              credentials: "include",
            }
          );

          if (response.ok) {
            setSendingStatus("sent");
          } else {
            setSendingStatus("error");
          }
        } catch {
          setSendingStatus("error");
        }
      } else {
        setSendingStatus("emptyMessage");
      }
    }
  }

  const [message, setMessage] = useState<string>(template);
  const [sendingStatus, setSendingStatus] = useState<SendingStatus>("idle");

  let info = "";
  switch (sendingStatus) {
    case "idle":
      info = "";
      break;
    case "emptyMessage":
      info = "Textfeld darf nicht leer sein!";
      break;
    case "sending":
      info = "";
      break;
    case "sent":
      info = "E-Mail erfolgreich verschickt.";
      break;
    case "error":
      info = "Fehler beim Verschicken des E-Mails!";
      break;
  }

  return (
    <div className="flex flex-col leading-relaxed max-w-[800px] text-gray-700">
      <div className="mb-4">
        <h1 className="text-lg mb-2 font-bold">Einführung</h1>
        <p className="my-2">
          Die haushälterische Bodennutzung und damit verbunden die
          Sicherstellung der Lebens- und Standortqualität sind
          Herausforderungen, denen sich der Kanton und die Gemeinden heute
          angesichts der zunehmenden Ansprüche an den Boden und der Zersiedelung
          vermehrt stellen müssen. Der Kanton Luzern hat mit seinem Richtplan
          2015 wesentliche Schritte zur Bewältigung dieser Aufgabe festgelegt.
          Von grosser Wichtigkeit bei der Ermittlung und Beurteilung des Bedarfs
          für Neueinzonungen sind die Reserven der Bauzonen mit den unüberbauten
          Bauzonen und dem Verdichtungspotential in überbauten Zonen.
        </p>
        <p className="my-2">
          In einem automatisierten Verfahren, welches sowohl die Gebäudeflächen
          wie auch die Parzellenflächen in den entsprechenden Bauzonen
          berücksichtigt, wird der Überbauungsstand (überbaut, unüberbaut oder
          teilweise überbaut) pro Parzelle in Prozent berechnet. Ob eine
          Parzelle oder ein Parzellenteil als unüberbaut oder teilweise überbaut
          gilt, wurde mit allgemeinen wie auch spezifischen Kriterien abhängig
          von der Grundnutzung (Zonenart PBG) definiert.
        </p>
        <h1 className="text-lg mt-4 font-bold">Webkarte</h1>
        <p className="my-2">
          Unter folgendem Link finden Sie Karten zur Orts- und Regionalplanung.
          <a
            href={process.env.REACT_APP_URL_URBAN_PLANNING}
            target="_blank"
            rel="noreferrer"
            className="flex flex-row space-x-2 text-blue-400"
          >
            <span>Orts- und Regionalplanung</span>
            <ExternalLink />
          </a>
        </p>
      </div>
      <div className="bg-gray-100 shadow-md p-4">
        <h2 className="text-md font-bold mb-2">
          Korrektur für unüberbaute Bauzonen melden
        </h2>
        <p className="w-3/4 max-w-2xl my-2">
          Bitte melden Sie uns Ihre Korrektur mittels folgender Vorlage:
        </p>
        <textarea
          className="border-2 border-gray-200 focus:border-blue-400 focus:ring-0 rounded-md text-gray-500 w-full h-48 border-1 resize-none"
          onChange={handleTextAreaChanged}
          value={message}
        ></textarea>
        <span className="text-sky-400 font-bold">{info}</span>
        <div className="flex flex-row space-x-4 items-center mt-4">
          <Button className="bg-blue-400" onClick={() => send()}>
            Senden
          </Button>
          <span
            className="cursor-pointer text-blue-400"
            onClick={fillInTemplate}
          >
            Vorlage erneut einfügen
          </span>
        </div>
      </div>
    </div>
  );
}
